import React from 'react';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import {LineupPlayerFinalTableHead} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-head';
import {LineupPlayerFinalTableRow} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-row';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';
import LockedPlayerGameMarker from 'components/molecules/locked-player-game-marker';
import PlayerInjury from 'components/molecules/player-injury';
import Const from 'constants';
import {StackedPlayerAnalyzerFactory} from 'components/organisms/lineup/components/stacked-player-analyzer-factory';

class LineupPlayersComponent extends BaseLineupPlayers {
    constructor(props) {
        super(props);
        this.stackPlayerAnalyzer = StackedPlayerAnalyzerFactory.createAnalyzer(
            {
                sport: Const.LEAGUE_NBA,
            },
            props,
        );
    }
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        const rows = lineup.players.map((player) => {
            return (
                <tr key={player.playerId} className={this.getRowClassName(player)}>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <LockedPlayerGameMarker player={player} />
                    </td>
                    <td>
                        <strong className={`player-name ${this.getStackClassName(player)}`}>{player.name}</strong>
                        <PlayerInjury player={player} />
                    </td>
                    <td className="td-team">
                        <TeamLogo teamName={player.team} />
                    </td>
                    <td className="td-vs">{this.getOpponentsDelimiter(player)}</td>
                    <td className="td-team">
                        <TeamLogo teamName={player.opponent} />
                    </td>
                    <td>{player.salary}</td>
                    <td>{this.getPlayerPointsView(player)}</td>
                    <LineupPlayerFinalTableRow points={player.fantasyPoints} />
                    <td>{player.projOwn.getValue()}%</td>
                    <td className="td-exchange">{this.getExchangePlayerButton({player, lineup})}</td>
                </tr>
            );
        });

        return (
            <table className="table">
                <tbody>
                    <tr>
                        <th className="td-pos">Pos</th>
                        <th />
                        <th>Name</th>
                        <th className="td-team">Team</th>
                        <th className="td-vs"></th>
                        <th className="td-team">Opp</th>
                        <th className="td-salary">Salary</th>
                        <th className="td-fpts">Fpts</th>
                        <LineupPlayerFinalTableHead />
                        <th className="td-pown">pOwn%</th>
                        <th className="td-exchange" />
                    </tr>
                    {rows}
                </tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games, players},
        lineupsData: {lineups, rawLineups},
        filterLineupsByPlayer,
        playerPositionStacking,
        stacks: {groups},
        runSettings,
    } = state;

    return {
        sportConfig,
        games,
        players,
        lineups,
        rawLineups,
        filterLineupsByPlayer,
        playerPositionStacking,
        keyPlayerStackingGroupsStateId: groups.getStateId(),
        runSettings,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
